module.exports = __webpack_public_path__ + "static/img/sex1.6e93307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/member/sex1.png
// module id = i1gr
// module chunks = 0